/* eslint-disable react-hooks/exhaustive-deps */
import { useTranslate } from 'hooks/useTranslate';
import { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Link } from 'react-router-dom';

import { resetStateSociety } from 'modules/_shared/redux/resetActions';
import { getUserSocieties } from 'modules/society/redux/societyActions';

import Page from 'modules/_shared/components/Pages/Page';
import Button, { ButtonVariants } from 'modules/_shared/components/Buttons';
import CardLoader from 'modules/_shared/components/Cards/CardLoader';
import SocietyCard from 'modules/society/components/SocietyCard';
import PageListHeader from 'modules/_shared/components/Headers/PageListHeader';

import './ParticipatedTable.scss';

function ParticipatedTable({ alternativeMenuOptions }) {
  const { t } = useTranslate();
  const dispatch = useDispatch();
  const { user } = useSelector((state) => state);

  const [participatedData, setParticipatedData] = useState([]);
  const [isLoadingData, setIsLoadingData] = useState(true);

  useEffect(() => {
    if (user) {
      getUserSocieties(
        user['_id'],
        'partner',
        setParticipatedData,
        'cards'
      ).then((result) => {
        if (!result?.length) {
          setIsLoadingData(false);
        }
      });
    }
  }, [user]);

  useEffect(() => {
    dispatch(resetStateSociety());
  }, []);

  return (
    <Page id="participated-societies-cards">
      <PageListHeader
        subTitle={t('ParticipatedTitle')}
        description={
          participatedData?.length === 0
            ? t('ParticipatedNoSocieties')
            : t('ParticipatedHaveSocieties', {
                count: participatedData?.length,
              })
        }
        actions={[
          <Link to="/diagrama-participadas">
            <Button variant={ButtonVariants.LIGHT} outlineStyle>
              <em className="icon ni ni-network" />
              <span className="d-none d-md-block">{t('Chart')}</span>
            </Button>
          </Link>,
          <Link to="/lista-participadas">
            <Button variant={ButtonVariants.LIGHT} outlineStyle>
              <em className="icon ni ni-view-list-wd" />
              <span className="d-none d-md-block">{t('View')}</span>
            </Button>
          </Link>,
        ]}
      />

      <div className="nk-content-wrap">
        <div className="cuadro-participadas__main d-flex flex-wrap g-gs">
          {participatedData?.length > 0 ? (
            participatedData.map((data) => (
              <SocietyCard
                data={data}
                userId={user['_id']}
                isAdmin={data?.isUserAdmin}
                alternativeMenuOptions={alternativeMenuOptions}
                key={data?.society?.['_id']}
              />
            ))
          ) : (
            <>
              <div className="w-100 pt-1">
                {isLoadingData && <CardLoader cards={6} />}
              </div>
            </>
          )}
        </div>
      </div>
    </Page>
  );
}

export default ParticipatedTable;
